require("./about/about");
require("./terms/terms");
require("./faq/faq");
require("./privacy/privacy");

'use strict';

angular.module('app.information', [
	'app.information.about', 
	'app.information.terms', 
	'app.information.faq',
	'app.information.privacy_page'
	])
.config([
  '$stateProvider', function($stateProvider) {
    return $stateProvider.state('app.information', {
      template: '<div class="information" ui-view></div>'
    });
  }
]);



// WEBPACK FOOTER //
// ./app.v2/components/information/information.js